import { render, staticRenderFns } from "./menu-hosting.vue?vue&type=template&id=7685fca6&"
import script from "./menu-hosting.vue?vue&type=script&lang=js&"
export * from "./menu-hosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports